import moment from 'moment';

export interface TimeOption {
  value: string;
  label: string;
}

export const generateTimeOptions = (): TimeOption[] => {
  const timeTable: TimeOption[] = [];

  for (let hour = 0; hour < 24; hour++) {
    timeTable.push({ value: `${hour}:00`, label: moment({ hour, minute: 0 }).format('hh:mm A') });
    timeTable.push({ value: `${hour}:15`, label: moment({ hour, minute: 15 }).format('hh:mm A') });
    timeTable.push({ value: `${hour}:30`, label: moment({ hour, minute: 30 }).format('hh:mm A') });
    timeTable.push({ value: `${hour}:45`, label: moment({ hour, minute: 45 }).format('hh:mm A') });
  }

  return timeTable;
};
